import angular from 'angular';
import releaseNotes from './releaseNotes';
import './style.scss';

export default angular
  .module('components.releaseNotes', [])
  .component('releaseNotes', releaseNotes).name;
